import { adminHttpClient } from '../../../commons/adminHttpClient'

export interface CompanyDetailsDataForSave {
  name: string
  addressLine1: string
  addressLine2?: string
  city: string
  stateId: string
  zipCode: string
  mainPhoneNumber: string
  companyTypeId: string
  ein: string
}

const saveForCompanyDetails = (data: CompanyDetailsDataForSave): Promise<any> => {
  return adminHttpClient.put('/AdminDashboard/CompanySettings/CompanyDetails', data)
}

export default saveForCompanyDetails
